import { render, staticRenderFns } from "./DepartamentosList.vue?vue&type=template&id=28be8b95"
import script from "./DepartamentosList.vue?vue&type=script&lang=js"
export * from "./DepartamentosList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports